import type { HTTPFunctions, NodePosition } from '../types';

const touchpoints = ({ get, put }: HTTPFunctions) => ({
  getTouchpoints: (id: string) => get(`/touchpoints/${id}`),
  putNodesPosition: (data: NodePosition[]) => put('/node/position', data),
});

export default touchpoints;
